import { useAppRouter } from '@/shared/lib/router'

import { useLevelContext } from '../contexts/LevelContext'

import { useLevelAnalytics } from '@/shared/lib/analytics/useChallengeAnalytics'
import { useFlow } from '@/shared/lib/steps-flow'
import { ChallengeStep, STEP_KIND } from '@/shared/lib/steps-flow/types'
import { UnavailableState } from '@/shared/ui/UnavailableState'

import { GameAtThePlace } from './Games/AtThePlace'
import { GameFile } from './Games/File'
import { GameIframe } from './Games/Iframe'
import { GameJigsaw } from './Games/Jigsaw'
import { GameMemory } from './Games/Memory'
import { GameMosaic } from './Games/Mosaic'
import { GameQuestion } from './Games/Question'
import { GameSlide } from './Games/Slide'
import { GameSorted } from './Games/Sorted'
import { GameStories } from './Games/Stories'
import { GameThisOrThat } from './Games/ThirOrThat'
import { GameVideo } from './Games/Video'
import { GameWordHunt } from './Games/WordHunt'
import { StepInitial } from './StepInitial'
import { StepIntro } from './StepIntro'
import { StepSummary } from './StepSummary'

const CHALLENGE_COMPONENTS: Record<
  string,
  React.ComponentType<{ step: ChallengeStep; challengeId: number }>
> = {
  word_hunt: GameWordHunt,
  this_or_that: GameThisOrThat,
  video: GameVideo,
  memory: GameMemory,
  question: GameQuestion,
  mosaic: GameMosaic,
  sorted: GameSorted,
  at_the_place: GameAtThePlace,
  jigsaw: GameJigsaw,
  stories: GameStories,
  slide: GameSlide,
  file: GameFile,
  iframe: GameIframe
}

export function StepRenderer() {
  const router = useAppRouter()
  const { state } = useFlow()
  const { levelPlayState } = useLevelContext()
  const step = state.steps[state.currentIndex]

  useLevelAnalytics()

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back()
      return
    }

    router.push('/jornadas')
  }

  if (!step) return null
  switch (step.kind) {
    case STEP_KIND.INITIAL:
      return <StepInitial step={step} />

    case STEP_KIND.INTRO:
      return <StepIntro step={step} />

    case STEP_KIND.CHALLENGE: {
      const Cmp = CHALLENGE_COMPONENTS[step.challengeKind]
      if (!Cmp) {
        const fallbackState =
          levelPlayState.kind === 'challenge_unavailable'
            ? levelPlayState
            : {
                title: 'Este desafio não está disponível agora',
                description:
                  'Não foi possível abrir este tipo de desafio no momento. Você pode voltar e escolher outro nível.'
              }

        return (
          <UnavailableState
            title={fallbackState.title}
            description={fallbackState.description}
            onAction={handleBack}
          />
        )
      }

      return (
        <Cmp
          key={step.id}
          step={step}
          challengeId={step.challengeId}
        />
      )
    }

    case STEP_KIND.SUMMARY:
      return <StepSummary />

    default:
      return null
  }
}
